var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffers = function SvgOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M16 3h2.4c.424 0 .831.167 1.131.464s.469.7.469 1.12v15.833c0 .42-.169.822-.469 1.12-.3.296-.707.463-1.131.463H5.6c-.424 0-.831-.167-1.131-.464S4 20.836 4 20.416V4.584c0-.42.169-.822.469-1.12C4.769 3.168 5.176 3 5.6 3H8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M14.4 1H9.6A1.6 1.6 0 0 0 8 2.6v.8A1.6 1.6 0 0 0 9.6 5h4.8A1.6 1.6 0 0 0 16 3.4v-.8A1.6 1.6 0 0 0 14.4 1M8 9h8M8 13h8M8 17h8"
  })));
};
export default SvgOffers;